import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  type RansackableKey,
  type RequestRansackableParams,
  type ToRansackableType,
} from '@repo/utils';

export interface RequestsState {
  filters?: ToRansackableType<RequestRansackableParams[]>;
  pagination: {
    itemsPerPage: number;
    currentPage: number;
  };
}

const initialState: RequestsState = {
  filters: {},
  pagination: {
    itemsPerPage: 10,
    currentPage: 1,
  },
};

export const requestsSlice = createSlice({
  name: 'requests',
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<Partial<RequestsState['filters']>>) => {
      if (action.payload) {
        state.filters = {
          ...state.filters,
          ...action.payload,
        };
      }
    },
    setPagination: (state, action: PayloadAction<Partial<RequestsState['pagination']>>) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
    resetFilterForKey: (state, action: PayloadAction<RansackableKey<RequestRansackableParams>>) => {
      state.filters = {
        ...state.filters,
        [action.payload]: undefined,
      };
    },
  },
});

export const {
  setFilter,
  resetFilterForKey,
  setPagination,
} = requestsSlice.actions;

export default requestsSlice.reducer;
